(function () {
  'use strict';

  class MacroCtrl {
    constructor(Keys, ServiceVfiltro, FactoryVfiltro, safetyService, Authenticator, blockUI, $state, $stateParams) {
      this.keys = Keys;
      this.factoryVfiltro = FactoryVfiltro;
      this.serviceVfiltro = ServiceVfiltro;
      this.authenticator = Authenticator;
      this.safetyService = safetyService;
      this.blockUI = blockUI;
      this.state = $state;
      this.stateParams = $stateParams;

      this.filtro = null;
      this.user = null;
      this.tabIndex = this.getValidatedTabIndex();

      this.initialize();
    }

    initialize() {
      this.blockUI.start();
      return this.initFilter()
        .then(() => this.loadUser())
        .then(() => this.loadReact())
        .finally(() => {
          this.blockUI.reset();
          this.blockUI.stop();
        });
    }

    initFilter() {
      return this.serviceVfiltro.init(
        this.factoryVfiltro.get([
          {
            name: 'uoId',
            key: this.keys.uo.name
          }
        ])
      ).then((filtro) => {
        this.filtro = filtro;
      });
    }

    loadUser() {
      return this.authenticator.getUser()
        .then((user) => {
          this.user = user;
        });
    }

    loadReact() {
      const appName = 'safetyApp',
          componentName = './MacroPageRoute',
          componentId = 'safety-macro-page',
          props = this.getReactProps();

      return this.safetyService
        .initialize()
        .then(() => this.safetyService.loadReactComponent(appName, componentName, componentId, props));
    }

    goToMacroGroupForm(macroGroupUUID) {
      this.state.go('root.macro.form', {
        macroGroupUUID: macroGroupUUID
      });
    }

    getValidatedTabIndex() {
      const tabIndex = Number(this.stateParams.tabIndex);

      if (tabIndex === 0 || tabIndex === 1) {
        return tabIndex;
      }

      return 0;
    }

    getReactProps() {
      return {
        user: this.user,
        filter: {
          ouId: this.filtro.find((f) => f.key === this.keys.uo.name).value.id
        },
        tabIndex: this.tabIndex,
        goToMacroGroupForm: (macroGroupUUID) => this.goToMacroGroupForm(macroGroupUUID)
      };
    }

  }

  angular
    .module('cadastros.macro')
    .controller('MacroCtrl', MacroCtrl);
}());
